import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";

/**
 * A small, warm reminder that shows on the Planner home only on Sundays.
 * Links out to the full /sunday-reset experience — does NOT inline the form.
 */
export default function SundayReminder() {
  if (new Date().getDay() !== 0) return null;
  return (
    <Link
      to="/sunday-reset"
      className="block group"
      data-testid="sunday-reminder-banner"
    >
      <div
        className="rounded-2xl border-2 border-primary/30 bg-card p-4 sm:p-5 shadow-sm relative overflow-hidden transition-all group-hover:border-primary/60"
        style={{
          backgroundImage:
            "radial-gradient(circle at 100% 0%, hsl(var(--primary) / 0.14), transparent 55%), radial-gradient(circle at 0% 100%, hsl(var(--primary) / 0.07), transparent 55%)",
        }}
      >
        <div className="flex items-center gap-4">
          <div className="size-12 rounded-2xl bg-primary/20 flex items-center justify-center shrink-0">
            <Sparkles strokeWidth={1.5} className="size-6 text-primary" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-primary">
              Sunday reset
            </div>
            <h3 className="font-display text-lg sm:text-xl font-bold tracking-tight leading-tight">
              Take a breath. Let's set the week up gently.
            </h3>
            <p className="text-xs sm:text-sm text-muted-foreground mt-0.5">
              Reflect on the week, prepare the next one. Five minutes for future you.
            </p>
          </div>
          <ArrowRight
            strokeWidth={1.5}
            className="size-5 text-primary/70 shrink-0 transition-transform group-hover:translate-x-1"
          />
        </div>
      </div>
    </Link>
  );
}
